import React, { useEffect, useContext } from "react";
import { getBillingMonthly } from "src/redux/analytics/analyticsThunk";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Spinner } from 'src/components/Spinner'
import { AppContext } from "../AppContext";
import { BillingMonthly } from "src/components/tableComponents/BillingMonthly";

const BillingTableMonthly = (props) => {
  const dispatch = useDispatch();
  let businessId;
  const context = useContext(AppContext);

  // Get current business id
  let businessIdObj = context.authState.businessIdentifiers.find((obj) => obj.type === "VATID");

  if (businessIdObj) {
    businessId = businessIdObj.id;
  } else {
    businessId = context.authState.businessIdentifiers[0].id;
  }

  // Load initial data
  const billingMonthlyParams = "?businessid=" + businessId + "&month=3";
  useEffect(() => {
    dispatch(getBillingMonthly(billingMonthlyParams));
  }, []);

  const _state = useSelector((state) => state.analytics, shallowEqual);

  const isLoading = _state.actionsLoading;

  return (
    <>
      {isLoading ? (
        <div>
          <Spinner />
        </div>
      ) : (
        <div>
          <BillingMonthly data={_state.billingMonthly} />
        </div>
      )}
    </>
  );
};

export default BillingTableMonthly;
